<template>
  <div class="container">
    <div v-for="item in items" :key="item.id">
      <input
        :id="item.id"
        v-model="selectedRef"
        type="radio"
        :value="item.id"
      />
      <label :for="item.id">
        <div class="icon">
          <i class="fa" :class="item.icon" />
        </div>
      </label>
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue'
const props = defineProps({
  modelValue: {
    type: String,
    default: 'one'
  },
  items: {
    type: Array,
    default: () => [
      { id: 'one', icon: 'fa-map' },
      { id: 'two', icon: 'fa-chart-bar' },
      { id: 'three', icon: 'fa-info-circle' }
    ]
  }
})
const emit = defineEmits(['update:modelValue'])
const selectedRef = ref(props.modelValue)
watch(selectedRef, newVal => {
  emit('update:modelValue', newVal)
})
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: white;
  width: 60px;
  height: 100%;
  padding: 54px 0 0;
  box-shadow: 2px 0 10px -2px rgba(0, 0, 0, 0.13);
}
input[type='radio'] {
  display: none;
  &:not(:disabled) ~ label {
    cursor: pointer;
  }
  &:disabled ~ label {
    color: hsla(150, 5%, 75%, 1);
    border-color: hsla(150, 5%, 75%, 1);
    box-shadow: none;
    cursor: not-allowed;
  }
}
label {
  display: flex;
  width: 40px;
  height: 40px;
  margin: 5px 0;
  border-radius: 10px;
  text-align: center;
  position: relative;
  justify-content: center;
  align-items: center;
  .icon {
    color: #616161;
  }
}
input[type='radio']:checked + label {
  background-color: #f1f1f1;
  .icon {
    color: var(--primary-color);
  }
}
input[type='radio']#control_05:checked + label {
  background: red;
  border-color: red;
}
</style>
